import { Button } from "components/DesignSystem/Button/Button";
import { Tag, type TagColorType } from "components/DesignSystem/Tag/Tag";
import { RightArrow } from "components/icons/RightArrow";
import { ACCENT_CLASS, type PendingAccent } from "./pendingSectionConfig";

type PendingTaskRowShellProps = {
  accent: PendingAccent;
  title: string;
  subtitle: string;
  actionLabel: string;
  tag?: { label: string; tone: TagColorType };
  onAction: () => void;
};

export const PendingTaskRowShell = ({
  accent,
  title,
  subtitle,
  actionLabel,
  tag,
  onAction,
}: PendingTaskRowShellProps) => (
  <div className="t-group t-relative t-flex t-flex-col t-gap-3 t-border-0 t-border-b t-border-solid t-border-neutral-10 t-bg-white last:t-border-b-0 t-px-4 t-py-5 md:t-flex-row md:t-items-start md:t-justify-between md:t-gap-4 md:t-px-6 md:t-py-7">
    <div
      className={`t-absolute t-left-0 t-top-4 t-bottom-4 t-w-0.5 t-rounded-r ${ACCENT_CLASS[accent]}`}
    />
    <div className="t-flex t-flex-col t-gap-1.5">
      <div className="t-flex t-flex-wrap t-items-center t-gap-x-3 t-gap-y-1">
        <div className="t-text-body t-text-text-60">{title}</div>
        {tag && (
          <span className="t-shrink-0">
            <Tag tagType={tag.tone} size="small" rounded icon={false}>
              {tag.label}
            </Tag>
          </span>
        )}
      </div>
      <div className="t-text-body-sm t-text-neutral-50">{subtitle}</div>
    </div>
    <Button
      customType="text"
      size="small"
      onClick={onAction}
      aria-label={actionLabel}
      className="t-shrink-0 t-self-start md:t-self-center hover:!t-bg-surface-transparent"
    >
      <span className="t-invisible group-hover:t-visible">{actionLabel}</span>
      <span className="t-absolute t-inset-y-0 t-right-3 t-flex t-items-center t-text-text-30 group-hover:t-hidden">
        <RightArrow />
      </span>
    </Button>
  </div>
);
